import React from 'react';
import FeaturesItem from './FeaturesItem';
import { Award, Baby, CircleFadingPlus, EarthLock, Gamepad2, HandCoins, Images, Languages, Loader, Palette } from 'lucide-react';

const features = [
  {
    title: 'Pictorial Learning',
    text: 'Engaging visual lessons that help kids easily understand basic concepts through colorful images and illustrations.',
    icon: Images
  },
  {
    title: 'Interactive Stories',
    text: 'Fun and educational stories with audio and animation that enhance reading skills and imagination.',
    icon: CircleFadingPlus
  },
  {
    title: 'Puzzles & Brain Games',
    text: 'Exciting puzzles and logic games designed to improve problem-solving, memory, and critical thinking.',
    icon: Gamepad2
  },
  {
    title: 'Creative Drawing',
    text: 'Easy-to-use drawing and coloring tools to boost creativity and hand-eye coordination.',
    icon: Palette
  },
  {
    title: 'Parental Control',
    text: 'Full control over accessible content and features, ensuring a safe and age-appropriate experience.',
    icon: Award
  },
  {
    title: 'Progress Tracking',
    text: 'Monitor your child’s learning journey with insights into their activity and performance.',
    icon: Loader
  },
  {
    title: 'Offline Mode',
    text: 'Access downloaded lessons and games anytime, even without an internet connection.',
    icon: EarthLock
  },
  {
    title: 'Multilingual Support',
    text: 'Content available in multiple languages to support diverse learning needs.',
    icon: Languages
  },
  {
    title: 'Child-Friendly Interface',
    text: 'A simple, colorful, and intuitive design that makes navigation easy for young users.',
    icon: Baby
  },
  {
    title: 'Freemium Access',
    text: 'Free version with ads and limited premium content; upgrade for a full, ad-free learning experience.',
    icon: HandCoins
  }
];

const Features = () => {
  return (
    <section className="bg-background flex flex-col justify-center text" id="features">
      <div className="container mx-auto">
        <div className="text-3xl text text-center mt-12 mb-5">Features</div>
        <div className="text text-base mb-12 text-center max-w-[900px] mx-auto">
          Kidster is packed with interactive and kid-friendly features designed to make learning fun and engaging. From pictorial lessons and animated
          stories to puzzles, games, and drawing tools, every feature supports creativity, critical thinking, and safe exploration—all with full
          parental control.
        </div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 grid-cols-1 gap-x-12 gap-y-16 mb-16">
          {features.map(f => (
            <FeaturesItem key={f.title} title={f.title} text={f.text} icon={f.icon} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
